import _ from 'lodash'
import { useEffect, useRef, useState } from 'react'

import {
  bestwesternCustomSearchCX,
  ChoiceCustomSearchCX,
  hiltonCustomSearchCX,
  hyattCustomSearchCX,
  IHGcustomSearchCX,
  marriottCustomSearchCX,
  radissonCustomSearchCX,
  TAcustomSearchCX,
  wyndhamCustomSearchCX
} from '../main/globalVariables'

const searchEngines = {
  TA: TAcustomSearchCX,
  IHG: IHGcustomSearchCX,
  choice: ChoiceCustomSearchCX,
  radisson: radissonCustomSearchCX,
  wyndham: wyndhamCustomSearchCX,
  marriott: marriottCustomSearchCX,
  hilton: hiltonCustomSearchCX,
  hyatt: hyattCustomSearchCX,
  bestwestern: bestwesternCustomSearchCX
}

const useCustomSearch = (searchEngine, callback) => {
  const [id, setId] = useState()

  useEffect(() => {
    setId(_.uniqueId('handleCS'))
  }, [])

  useEffect(() => {
    if (id) {
      window[id] = url => callback(url)
    }
  }, [callback, id])

  const cx = searchEngines[searchEngine]

  if (!cx) {
    throw new Error('search engine does not exist')
  }

  const popupRef = useRef()

  function open(query) {
    popupRef.current = window.open(
      `/customSearch.html?search=aff&q=${encodeURI(
        query.replace(/&/, '')
      )}&cx=${cx}&opener=${id}`,
      '',
      'location=0,status=1,scrollbars=0, width=1000,height=700'
    )
  }

  function close() {
    popupRef.current.close()
  }

  function alert(str) {
    popupRef.current.alert(str)
  }

  return [open, close, alert]
}

export default useCustomSearch
